import React from 'react';
import SVGLoader from './SVGLoader';

const AudioPlayIcon = ({ ...rest }) => {
  return (
    <SVGLoader
      viewboxHeight={16}
      viewboxWidth={16}
      width={16}
      height={16}
      {...rest}
    >
      <g clipPath="url(#clip0_695_23407)">
        <path
          d="M14.9625 7.13126L1.90625 0.600009C1.75756 0.526679 1.59262 0.492475 1.42704 0.500631C1.26145 0.508787 1.10067 0.559033 0.959906 0.646621C0.81914 0.734208 0.703034 0.856243 0.622561 1.00119C0.542088 1.14614 0.499905 1.30922 0.5 1.47501V14.525C0.499905 14.6908 0.542088 14.8539 0.622561 14.9988C0.703034 15.1438 0.81914 15.2658 0.959906 15.3534C1.10067 15.441 1.26145 15.4912 1.42704 15.4994C1.59262 15.5075 1.75756 15.4733 1.90625 15.4L14.9625 8.86876C15.1246 8.78877 15.2611 8.66501 15.3566 8.51148C15.452 8.35796 15.5026 8.18079 15.5026 8.00001C15.5026 7.81923 15.452 7.64206 15.3566 7.48853C15.2611 7.33501 15.1246 7.21125 14.9625 7.13126Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_695_23407">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </SVGLoader>
  );
};

export default AudioPlayIcon;
